export default __webpack_public_path__ + "assets/images/89ed2ec4d78e002a99fd0e75dbce3151.png";